import { getMyProfile } from './states';

export const services = {
  getMyProfile,
};
